import { useFormSociogram } from '@BUP/hooks';
import React, { createContext } from 'react';

export const SociogramContext = createContext();

export const SociogramContextProvider = ({ children }) => {
  const SociogramFormValues = useFormSociogram();

  return (
    <SociogramContext.Provider value={SociogramFormValues}>
      {children}
    </SociogramContext.Provider>
  );
};
